/**
 * View component for /user/login
 * 
 * Allows a user to login with their email or SSO.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Redirect, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import routeUtils from '../../../global/utils/routeUtils';

// import actions actions
import * as userActions from '../userActions';
import * as userEventActions from '../../userEvent/userEventActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Modal from '../../../global/components/modals/Modal.js.jsx';
import Base from '../../../global/components/BaseComponent.js.jsx';

// import user components
import UserLoginLayout from '../components/UserLoginLayout.js.jsx';
import UserLoginForm from '../components/UserLoginForm.js.jsx';
import { EmailInput } from '../../../global/components/forms';

import classNames from 'classnames';

class UserLogin extends Base {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ''
      , isErrorModalOpen: false
      , isSSOModalOpen: false
      , isMultSSOModalOpen: false
      , user: {
        username: ''
        , password: ''
      }
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
      , '_toggleErrorModal'
      , '_goToResetPass'
      , '_toggleSSOModal'
      , '_getSSOLinks'
    );
  }

  componentDidMount() {
    const { history, loggedInUser, location } = this.props;
    const searchObject = routeUtils.objectFromQueryString(location.search);
    if (loggedInUser && loggedInUser._id) {
      // already logged in, forward to redirect or root
      history.push(searchObject.redirect || "/")
    } else {
      const { email } = searchObject;
      // not logged in
      // build the callback url where we will redirect after login on Rome
      const redirect = `${window.location.origin}${searchObject.redirect || "/"}`;
      // forward to Rome login page, TODO: make this configurable for prod
      window.location.assign(`${hubUrl}/user/login?redirect=${redirect}${email ? `&email=${email}` : ''}`);
    }
  }

  // NOTE: Above is only for demo. We will need to move the stuff below to Rome when we are ready to use it.
  // componentDidMount() {
  //   const { history, loggedInUser, location } = this.props;
  //   if(loggedInUser && loggedInUser._id) {
  //     // already logged in, forward to root
  //     history.push('/')
  //   }

  //   const searchObject = routeUtils.objectFromQueryString(location.search);
  //   // console.log("MOUNT SEARCH OBJECT", searchObject)
  //   if(searchObject.error) {
  //     console.log("login error", this.props.location.search)
  //     let errorCode = this.props.location.search.split("=")[1]
  //     // TODO: convert these into better error messages - see usersApi for options
  //     // in general, either "no matching user", "not allowed", or "other" (ex - that provider doesn't exist)
  //     let errorMessage = errorCode.includes("matching") ? "Problem finding matching user account" : "Problem logging in via 3rd party. Please contact an administrator."

  //     this.setState({ errorMessage: errorMessage });
  //     this._toggleErrorModal();
  //   } else if(searchObject.redirect) {
  //     this.setState({
  //       relayStateString: JSON.stringify(searchObject)
  //     })
  //   }
  // }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    if(nextProps.status === "error") {
      alert(nextProps.error.message);
    }
  }

  _handleFormChange(e) {
    var nextState = this.state.user;
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  }

  _handleFormSubmit(e) {
    e.preventDefault();
    const { dispatch, history, location } = this.props;
    dispatch(userActions.sendLogin(this.state.username, this.state.password)).then((action) => {
      if(action.success) {
        this.props.dispatch(userEventActions.sendCreateUserEvent({
          eventType: "user"
          , eventAction: "login"
        }));

        // 1.22 - change this functionality to use query params. we need this to work with sso logins too.
        const searchObject = routeUtils.objectFromQueryString(location.search);
        history.push(searchObject.redirect || "/")

      } else {
        this.props.dispatch(userEventActions.sendCreateUserEvent({
          eventType: "user"
          , eventAction: "failed-login"
          , description: this.state.username
        }));
        this.setState({ errorMessage: action.error });
        this._toggleErrorModal();
      }
    })
  }

  _toggleErrorModal() {
    this.setState({ isErrorModalOpen: !this.state.isErrorModalOpen });
  }

  _goToResetPass() {
    const { history } = this.props;
    history.push('/user/forgot-password')
  }

  _toggleSSOModal() {
    this.setState({ isSSOModalOpen: !this.state.isSSOModalOpen });
  }

  _getSSOLinks() {
    let { user, relayStateString } = this.state;
    console.log(user)

    if(user.username && user.username.length > 0) {
      // + more checks for valid email address
      this.props.dispatch(userActions.sendGetSSOLinks(user.username)).then(json => {
        console.log(json)
        if(!json.success) {
          // generic error
          this.setState({
            isSSOModalOpen: false
            , isErrorModalOpen: true
            , errorMessage: "Your account is not configured to use SSO. Please try logging in with an email and password. If problems persist please contact an Admin."
          })
        } else if(json.ssoProviderLinks && json.ssoProviderLinks.length == 1) {
          // redirect to it!
          console.log("redirecting to SSO provider")
          // console.log(json)
          // TODO: include redirect
          // DEBUG!!!!
          if(relayStateString) {
            window.location.href = json.ssoProviderLinks[0].link + `?RelayState=${relayStateString}`;
          } else {
            window.location.href = json.ssoProviderLinks[0].link;
          }
        } else {
          console.log("opening multiple SSO chooser modal")
          console.log(json.ssoProviderLinks)
          this.setState({
            isSSOModalOpen: false
            , isMultSSOModalOpen: true
          })
        }
      })

    }
  }

  render() {
    const { ssoProviderLinks, location } = this.props;
    const { user, relayStateString } = this.state;
    return null; //  for demo (and once we take this live) this is only a redirect to Rome and we don't need to render anything
    return (
      <UserLoginLayout>
        <Helmet
          title={"Login | Pro-ficiency"}
        />

        <div className="yt-container user-login-container">
          <div className="yt-row center-horiz space-around">
            <div className="yt-col full s_40 m_33 l_30">
              <UserLoginForm
                user={user}
                handleFormSubmit={this._handleFormSubmit}
                handleFormChange={this._handleFormChange}
                location={this.props.location}
                toggleSSOModal={this._toggleSSOModal}
              />
            </div>
            <div className="yt-col full s_50 m_60 l_60 -hero-container">
              <div className="-hero"></div>
            </div>
            
          </div>
          <Modal
            btnColor="info"
            closeAction={() => this.setState({ isSSOModalOpen: false })}
            closeText="Cancel"
            confirmAction={() => this._getSSOLinks()}
            confirmText="Log In"
            isOpen={this.state.isSSOModalOpen}
            modalClasses="info"
            modalHeader={<span>Log In to Pro-ficiency with SSO</span>}
          >
            <div className="form-container">
              <span></span>
              <EmailInput
                name="username"
                label="Email Address"
                value={user.username}
                change={this._handleFormChange}
                required={true}
              />
            </div>
          </Modal>

          <Modal
            btnColor="info"
            closeAction={() => this.setState({ isMultSSOModalOpen: false })}
            closeText="Cancel"
            isOpen={this.state.isMultSSOModalOpen}
            modalClasses="info"
            modalHeader={<span>Choose SSO Provider</span>}
          >
            <div className="form-container">
              <span></span>
              { ssoProviderLinks.map(providerLink =>
                <div key={providerLink.link}>
                  <br/>
                  { relayStateString ?
                    <a href={providerLink.link + `?RelayState=${relayStateString}`} className="yt-btn warning">{providerLink.name}</a>
                    :
                    <a href={providerLink.link} className="yt-btn warning">{providerLink.name}</a>
                  }
                </div>
              )}
            </div>
          </Modal>

          <AlertModal
            alertMessage={this.state.errorMessage}
            alertTitle="Error with sign in"
            closeAction={this._toggleErrorModal}
            confirmAction={this._toggleErrorModal}
            confirmText="Try again"
            declineText="Reset Password"
            declineAction={this._goToResetPass}
            isOpen={this.state.isErrorModalOpen}
            type="danger"
          />
        </div>
      </UserLoginLayout>
    )
  }
}

UserLogin.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    loggedInUser: store.user.loggedIn.user
    , ssoProviderLinks: store.user.otherUserInfo.ssoProviderLinks
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UserLogin)
);



// WEBPACK FOOTER //
// modules/user/views/UserLogin.js.jsx